module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_Foamcore_MockedUp.1086ecd5.jpg";